import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppStore } from '../../store/useAppStore'
import { useTelegramWebApp } from '../../hooks/useTelegramWebApp'
import { useTelegramBackButton } from '../../hooks/useTelegramBackButton'
import {
  useFavorites,
  useCards,
  useCategories,
  useAddToFavorites,
  useRemoveFromFavorites,
  useContentAccess,
} from '../../hooks/useApi'
import { useFavoritesData } from './hooks'
import {
  ProfileHeader,
  SubscriptionSection,
  FavoritesSection,
} from './components'
import './ProfilePage.css'

const ProfilePage = () => {
  const { user, subscription, favorites, hasActiveSubscription } = useAppStore()
  const { hapticFeedback } = useTelegramWebApp()
  const navigate = useNavigate()
  const [searchQuery, setSearchQuery] = useState('')

  // Показываем кнопку "Назад" в Telegram WebApp
  useTelegramBackButton(true)

  // Загружаем данные
  const { data: favoritesData, isLoading: favoritesLoading } = useFavorites()
  const { data: cardsData, isLoading: cardsLoading } = useCards()
  const { hasSubscription } = useContentAccess()
  const { data: categoriesData, isLoading: categoriesLoading } =
    useCategories(hasSubscription)

  // API мутации для избранного
  const addToFavoritesMutation = useAddToFavorites()
  const removeFromFavoritesMutation = useRemoveFromFavorites()

  // Обработчики событий
  const handleSubscribeClick = () => {
    hapticFeedback('light')
    // TODO: Реализовать переход к покупке подписки
  }

  const handleSettingsClick = () => {
    hapticFeedback('light')
    // Переход к техподдержке в Telegram
    window.open('https://t.me/secretchathelp', '_self')
  }

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
  }

  const clearSearch = () => {
    setSearchQuery('')
  }

  // Функция для переключения избранного с API
  const handleToggleFavorite = async (itemId: string) => {
    const cardId = parseInt(itemId)
    const isFavorite = favorites.includes(itemId)

    try {
      if (isFavorite) {
        await removeFromFavoritesMutation.mutateAsync({ card_id: cardId })
      } else {
        await addToFavoritesMutation.mutateAsync({ card_id: cardId })
      }
    } catch (error) {
      console.error('Ошибка при изменении избранного:', error)
    }
  }

  // Получаем данные избранного
  const { favoriteCards, hierarchicalFavoriteCards } = useFavoritesData({
    cardsData,
    favorites,
    searchQuery,
    categoriesData,
  })

  return (
    <div className="profile-page">
      <ProfileHeader user={user} />

      <SubscriptionSection
        hasActiveSubscription={hasActiveSubscription}
        subscription={subscription}
        onSubscribeClick={handleSubscribeClick}
        onSettingsClick={handleSettingsClick}
      />

      <FavoritesSection
        hasActiveSubscription={hasActiveSubscription}
        favorites={favorites}
        favoritesLoading={favoritesLoading}
        cardsLoading={cardsLoading}
        categoriesLoading={categoriesLoading}
        favoriteCards={favoriteCards}
        hierarchicalFavoriteCards={hierarchicalFavoriteCards}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        onClearSearch={clearSearch}
        onToggleFavorite={handleToggleFavorite}
      />
    </div>
  )
}

export default ProfilePage
